import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { RestApiService } from '../../../common/rest-api/services/rest-api.service';
import { EmployeeProduct } from '../models/employee-products.model';
import { WorkOrderProduct } from '../models/work-order-product.model';
import { WorkOrderGarment } from '../models/work-order-garment.model';
import { IWebCatOrder } from '../../mobile/models/web-cat-order';
import { StringDecoder } from 'string_decoder';

  
@Injectable({
providedIn: 'root',
})
export class ReplaceWorkOrderService extends RestApiService<EmployeeProduct>{

    //protected resourcePath = '/emp-product';
    protected modelType = EmployeeProduct;

   
    async GetReplaceGarmentDetails(body:string[]): Promise<any[]> {
        this.resourcePath = '/garment-report';
        const url = this.buildEndpointUrl(`garment-code/List`);

        const response = await this.cloudApiMiddleware.cloudRequest<any[]>({
            url,
            body
        }, 'POST');

        return response;
    }
    async SaveReplaceGarmentDetails(userId:string | number ,stopName:string,body:string[]): Promise<any[]> {
        this.resourcePath = '/route';
        const url = this.buildEndpointUrl(`garment-replace/Save/${userId}/${stopName}`);

        const response = await this.cloudApiMiddleware.cloudRequest<any[]>({
            url,
            body
        }, 'POST');

        return response;
    }
   

}